import {
  PerformanceReturnDetails,
  Stream,
  StreamDetails,
} from 'types/PerformanceReturns';

export const StreamList: Array<Stream> = [
  {
    streamId: '6142d72a-6861-4451-9f83-64ffdc0de1f8',
    benchmarkId: '97968c1e-e847-4efd-b09d-375866c35c6c',
    dateCreated: '2022-07-21T14:24:06Z',
  },
  {
    streamId: '9cfacafc-f00b-4c52-856f-3b04281253ae',
    benchmarkId: 'e1615843-5273-4d66-ba6e-6566787de6d8',
    dateCreated: '2022-11-11T16:03:33Z',
  },
  {
    streamId: '2c043888-8c2e-4bc9-a6e3-fa51efc40bef',
    benchmarkId: '33a7348d-b575-45fb-973a-350579df01b0',
    dateCreated: '2022-11-02T02:08:10Z',
  },
  {
    streamId: '11ece35f-01c5-465d-929c-5f5f5d90e2b3',
    benchmarkId: '1ce6f119-b7ab-4413-8e4c-1e6325d172b7',
    dateCreated: '2023-01-15T08:19:56Z',
  },
  {
    streamId: '32c68ae6-3865-4533-adde-ad9ef225db89',
    benchmarkId: 'b04fc4ec-8ccd-4b57-afbe-919f759e1ff1',
    dateCreated: '2023-05-04T10:35:19Z',
  },
  {
    streamId: 'e6664c3e-6f1a-46fb-b817-3285dc22ac7b',
    benchmarkId: '20b65540-c2e0-4dfd-9361-c7af55a855cc',
    dateCreated: '2022-09-17T05:22:06Z',
  },
  {
    streamId: 'd1b079fb-215f-4be5-8e7a-e2a068a46a06',
    benchmarkId: 'd812ee3e-5e65-4f50-9654-8f98c869b2a2',
    dateCreated: '2023-01-07T00:47:44Z',
  },
  {
    streamId: 'c0c6932c-9631-4dad-857c-8b6235629275',
    benchmarkId: 'ee7c5c14-cd6e-44e4-aac8-1b6d2b1a7381',
    dateCreated: '2022-11-13T19:21:17Z',
  },
  {
    streamId: 'd5cb1ee5-5f3f-4753-8164-040462a660a7',
    benchmarkId: '19e70057-b1f0-46f5-a9c9-b73657d43086',
    dateCreated: '2022-06-02T01:02:41Z',
  },
  {
    streamId: '8874828f-56aa-433e-b49c-c5f61eefba6d',
    benchmarkId: '8bbc5eac-bdcb-4439-b0e1-159b53b20f4b',
    dateCreated: '2022-11-03T11:44:55Z',
  },
  {
    streamId: '13dcc9b8-3c04-401f-9a1c-0dbffca4808e',
    benchmarkId: '101b5290-ed5c-419e-8174-a9aa72df1592',
    dateCreated: '2022-10-09T04:40:36Z',
  },
  {
    streamId: 'e671b066-f106-4f36-a31c-e2a742e08b06',
    benchmarkId: '5f6fec58-62fd-4981-aee3-8c1a5974f3e0',
    dateCreated: '2022-06-21T22:45:36Z',
  },
  {
    streamId: '0419c54d-4347-4a43-a29b-2f5fb2386b78',
    benchmarkId: '8d265397-837d-4965-af11-3449a50f9679',
    dateCreated: '2022-09-03T09:11:53Z',
  },
  {
    streamId: 'c506fcca-fe20-40af-bbaf-37d81d2968cf',
    benchmarkId: '2599e06d-1790-4308-835d-765fed009a1a',
    dateCreated: '2023-02-14T00:31:52Z',
  },
  {
    streamId: '29ad12b3-3f33-42cf-be67-8f5904fb7f17',
    benchmarkId: '7157eb48-ed69-45f1-9522-49acb47f0918',
    dateCreated: '2022-07-10T20:04:53Z',
  },
  {
    streamId: '27e86395-a12d-4db0-b31c-e34bb323bbda',
    benchmarkId: '1c92feb6-4512-471c-a6e2-e458290a5f22',
    dateCreated: '2022-07-19T03:37:44Z',
  },
  {
    streamId: 'feea1a07-1815-429a-993c-868d2d462aa6',
    benchmarkId: 'a7263591-cdfc-4cfa-b7fd-aeb305c17548',
    dateCreated: '2022-12-21T05:24:44Z',
  },
  {
    streamId: '42efeafe-e3f5-49aa-9ecb-d59208d8ae10',
    benchmarkId: '9826518f-93df-4090-b16a-d6042dd765f3',
    dateCreated: '2022-08-15T04:55:04Z',
  },
  {
    streamId: 'ddf2f2d7-594d-47ba-87b2-1e6d66b865b3',
    benchmarkId: '0554bb87-4422-428f-b27c-72c6bb380007',
    dateCreated: '2023-05-16T21:37:19Z',
  },
  {
    streamId: 'e1e5bfb2-3f43-41d6-9251-89573ee1b309',
    benchmarkId: 'd10150a7-6d8e-4deb-9b7a-28e1878ac2c1',
    dateCreated: '2022-12-08T10:09:16Z',
  },
];

export const StreamDetailsList: Array<StreamDetails> = [];

export const StreamDetailsObj: StreamDetails = {
  streamId: '6142d72a-6861-4451-9f83-64ffdc0de1f8',
  dateCreated: '2023-05-01',
  benchmark: {
    id: '',
    typeId: 6,
    calculationFrequencyId: 2,
  },
  calculationFrequencyId: 2,
  performanceReturns: [
    {
      date: '2023-05-31',
      value: 0.0534,
    },
    {
      date: '2023-04-30',
      value: 0.037,
    },
    {
      date: '2023-03-31',
      value: 0.021,
    },
    {
      date: '2023-02-28',
      value: 0.074,
    },
    {
      date: '2023-01-31',
      value: 0.08,
    },
    {
      date: '2022-12-31',
      value: 0.072,
    },
    {
      date: '2022-11-30',
      value: 0.03,
    },
    {
      date: '2023-10-31',
      value: 0.013,
    },
    {
      date: '2023-09-30',
      value: 0.069,
    },
    {
      date: '2022-08-31',
      value: 0.036,
    },
    {
      date: '2022-07-31',
      value: 0.0,
    },
    {
      date: '2022-06-30',
      value: 0.017,
    },
    {
      date: '2022-05-31',
      value: 0.069,
    },
    {
      date: '2022-04-30',
      value: 0.037,
    },
  ],
};

export const StreamDetailsObj2: StreamDetails = {
  streamId: '6142d72a-6861-4451-9f83-64ffdc0de1f8',
  dateCreated: '2023-05-01',
  benchmark: {
    id: '',
    typeId: 6,
    calculationFrequencyId: 2,
  },
  calculationFrequencyId: 2,
  performanceReturns: [
    {
      date: '2023-05-31',
      value: 0.03,
    },
    {
      date: '2023-04-30',
      value: 0.039,
    },
    {
      date: '2023-03-31',
      value: 0.024,
    },
    {
      date: '2023-02-28',
      value: 0.06,
    },
    {
      date: '2023-01-31',
      value: 0.08,
    },
    {
      date: '2022-12-31',
      value: 0.05,
    },
    {
      date: '2022-11-30',
      value: 0.06,
    },
    {
      date: '2023-10-31',
      value: 0.03,
    },
    {
      date: '2023-09-30',
      value: 0.049,
    },
    {
      date: '2022-08-31',
      value: 0.036,
    },
    {
      date: '2022-07-31',
      value: 0.02,
    },
    {
      date: '2022-06-30',
      value: 0.019,
    },
    {
      date: '2022-05-31',
      value: 0.065,
    },
    {
      date: '2022-04-30',
      value: 0.027,
    },
  ],
};

export const StreamDetailsData = {
  data: StreamDetailsObj,
};

export const StreamDetailsData2 = {
  data: StreamDetailsObj2,
};

export const StreamListData = {
  data: StreamList,
};

export const PrdDataStaticWeightedData = {
  streamId: '1',
  asOfDate: '2022-08-31',
  value: 0.081,
  calculationFrequencyId: 2,
  isNonBusinessDay: false,
  isLagged: false,
  benchmark: {
    id: '2',
    typeId: 6,
    calculationFrequencyId: 2,
    weightingMethodologyId: 1,
  },
  returnComponents: [
    {
      weightingComponent: undefined,
      returnComponent: {
        resourceId: 124,
        benchmarkId: '2',
        tagId: '2',
        name: 'My Return Component',
      },
      contributionToReturn: 0.01,
      weight: 0.25,
      weightingMarketValue: 3,
      hadBasisPointAdjustmust: false,
      isLagged: false,
      return: 0.063,
    },
    {
      weightingComponent: undefined,
      returnComponent: {
        resourceId: 124,
        benchmarkId: '2',
        tagId: '2',
        name: 'My Return Component 2',
      },
      contributionToReturn: 0.01,
      weight: 0.75,
      weightingMarketValue: 3,
      hadBasisPointAdjustmust: true,
      isLagged: false,
      return: 0.023,
    },
  ],
} as PerformanceReturnDetails;

export const PrdDataStaticWeightedData2 = {
  streamId: '2',
  asOfDate: '2022-08-31',
  value: 0.1,
  calculationFrequencyId: 2,
  isNonBusinessDay: false,
  isLagged: false,
  benchmark: {
    id: '2',
    typeId: 6,
    calculationFrequencyId: 2,
    weightingMethodologyId: 1,
  },
  returnComponents: [
    {
      weightingComponent: undefined,
      returnComponent: {
        resourceId: 124,
        benchmarkId: '2',
        tagId: '2',
        name: 'My Return Component',
      },
      contributionToReturn: 0.01,
      weight: 0.25,
      weightingMarketValue: 3,
      hadBasisPointAdjustmust: false,
      isLagged: true,
      return: 0.04,
    },
    {
      weightingComponent: undefined,
      returnComponent: {
        resourceId: 124,
        benchmarkId: '2',
        tagId: '2',
        name: 'My Return Component 2',
      },
      contributionToReturn: 0.03,
      weight: 0.75,
      weightingMarketValue: 3,
      hadBasisPointAdjustmust: true,
      isLagged: false,
      return: 0.05,
    },
  ],
} as PerformanceReturnDetails;
